module.exports = new __parcel__URL__("hi-tom_8.38b2f80d.mp3").toString();